import { Bitbucket } from 'logos';
import { DialogTitleWithIcon } from 'shared/MultiStepDialog';
import { TitleProps } from '../types';

export const Title = ({ text }: TitleProps) => {
  return (
    <DialogTitleWithIcon text={text}>
      <Bitbucket size={24} />
    </DialogTitleWithIcon>
  );
};
